<mat-card>
  <mat-card-header class="header-programa">
    <mat-card-title>{{ programaTitulo }}</mat-card-title>
    <div class="header-actions">
      <span>Comparar</span>
      <mat-slide-toggle class="lock-allowed-compare" [checked]="comparar" [disabled]="bloqueoInteraccion || toggleDeshabilitadoComparar"
        (change)="onCompararChanged($any($event).checked)">
      </mat-slide-toggle>
      <button mat-icon-button type="button" (click)="toggleExpanded()">
        <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content *ngIf="expanded">
    <section class="section-block">
      <h3>PARÁMETROS DE LA COTIZACIÓN</h3>
      <div class="param-grid">
        <div class="param-row" *ngIf="!ocultarProporcionalidad" [class.locked-visual]="bloqueoInteraccion">
          <label>Proporcionalidad:</label>
          <mat-radio-group [(ngModel)]="proporcionalidad" [disabled]="bloqueoInteraccion" (ngModelChange)="onProporcionalidadChanged($event)">
            <mat-radio-button value="SI">SI</mat-radio-button>
            <mat-radio-button value="NO">NO</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="param-row" *ngIf="proporcionalidad === 'SI'" [class.locked-visual]="bloqueoInteraccion">
          <mat-form-field appearance="outline" class="accent-control fecha-ingreso-field" floatLabel="always">
            <mat-label>Fecha de ingreso</mat-label>
            <input matInput [matDatepicker]="pickerIngreso" [(ngModel)]="fechaIngreso" [disabled]="bloqueoInteraccion" (ngModelChange)="onFechaIngresoChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="pickerIngreso" [disabled]="bloqueoInteraccion"></mat-datepicker-toggle>
            <mat-datepicker #pickerIngreso></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="accent-control" floatLabel="always">
            <mat-label>Corte</mat-label>
            <input
              matInput
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="2"
              min="1"
              max="30"
              step="1"
              [ngModel]="corte"
              [disabled]="bloqueoInteraccion"
              (ngModelChange)="onDiaCorteChanged($event)"
              (keydown)="onDiaCorteKeydown($event)"
              (paste)="onDiaCortePaste($event)"
              placeholder="1 - 30">
          </mat-form-field>

          <mat-form-field appearance="outline" class="accent-control" floatLabel="always">
            <mat-label>Días proporcionalidad</mat-label>
            <input matInput [value]="diasProporcionalidad" readonly>
          </mat-form-field>
        </div>

        <div class="param-row" [class.locked-visual]="bloqueoInteraccion">
          <label>Cuota Inscripción:</label>
          <mat-radio-group [(ngModel)]="cuotaInscripcion" [disabled]="bloqueoInteraccion" (ngModelChange)="onCuotaInscripcionChanged($event)">
            <mat-radio-button value="SI">SI</mat-radio-button>
            <mat-radio-button value="NO">NO</mat-radio-button>
          </mat-radio-group>
        </div>


        <div class="param-row" *ngIf="cuotaInscripcion === 'SI'" [class.locked-visual]="bloqueoInteraccion">
          <mat-form-field appearance="outline" class="accent-control" floatLabel="always">
            <mat-label>Valor a pagar</mat-label>
            <input matInput [value]="'$ ' + formatCurrency(valorPagarCuotaInscripcion)" readonly>
          </mat-form-field>
        </div>

        <div class="param-row" *ngIf="columnaValorTabla === 'periodoPronto'" [class.locked-visual]="bloqueoInteraccion">
          <label>Pronto Pago:</label>
          <mat-form-field appearance="outline" class="pronto-pago-meses-field accent-control" floatLabel="always" [class.mdc-disabled]="bloqueoInteraccion">
            <mat-select [(ngModel)]="prontoPagoMeses" [disabled]="bloqueoInteraccion" (ngModelChange)="onProntoPagoMesesChanged($event)">
              <mat-option *ngFor="let mes of [3,4,5,6,7,8,9,10,11,12]" [value]="mes">{{ mes }}</mat-option>
            </mat-select>
          </mat-form-field>
          <span>meses</span>
        </div>

        <div class="param-row lock-allowed-tarifa-row">
          <label>Mostrar tarifa de asociado Coomeva:</label>
          <mat-slide-toggle
            class="lock-allowed-tarifa"
            [(ngModel)]="mostrarTarifaAsociado"
            [disabled]="bloqueoInteraccion"
            (change)="onMostrarTarifaAsociadoChanged($any($event).checked)">
          </mat-slide-toggle>
        </div>
      </div>
    </section>
    </mat-card-content>


  <mat-card-content>
    <section class="section-block">
      <h3>RESUMEN DE LA COTIZACIÓN</h3>
      <div class="search-row lock-allowed-search-row">
        <mat-form-field appearance="outline" class="search-field lock-allowed-search-field" [class.search-field-locked]="bloqueoInteraccion">
          <mat-label>Buscador general</mat-label>
          <input matInput [(ngModel)]="searchText" (keyup.enter)="buscar()">
        </mat-form-field>

        <button mat-icon-button class="btn-search-icon lock-allowed-search-button" type="button" (click)="buscar()">
          <mat-icon>search</mat-icon>
        </button>

        <button mat-raised-button class="btn-clean-pill lock-allowed-search-button" type="button" (click)="limpiar()">LIMPIAR</button>
      </div>

      <p class="nota-iva-incluido" role="note">Valores con IVA incluido*</p>

      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
            <td mat-cell *matCellDef="let row">{{ row.nombre }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>TOTAL</strong></td>
          </ng-container>

          <ng-container matColumnDef="precioBaseMensual">
            <th mat-header-cell *matHeaderCellDef>PRECIO BASE MENSUAL</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.precioBaseMensual || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalPrecioBaseMensual || 0) }}</strong></td>
          </ng-container>

          <ng-container matColumnDef="precioBaseMensualAnexos">
            <th mat-header-cell *matHeaderCellDef>PRECIO BASE MENSUAL ANEXOS</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.precioBaseMensualAnexos || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalPrecioBaseMensualAnexos || 0) }}</strong>
            </td>
          </ng-container>

          <ng-container matColumnDef="descuentosCampana">
            <th mat-header-cell *matHeaderCellDef>DESCUENTOS POR CAMPAÑA</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.descuentosCampana || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalDescuentosCampana || 0) }}</strong></td>
          </ng-container>

          <ng-container matColumnDef="pagoProporcionalIngresoAnticipado">
            <th mat-header-cell *matHeaderCellDef>PAGO PROPORCIONAL POR INGRESO ANTICIPADO</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.pagoProporcionalIngresoAnticipado || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalPagoProporcionalIngresoAnticipado || 0)
                }}</strong></td>
          </ng-container>

          <ng-container matColumnDef="cuotaInscripcion">
            <th mat-header-cell *matHeaderCellDef>CUOTA DE INSCRIPCIÓN</th>
            <td mat-cell *matCellDef="let row">
              {{ aplicacionCuotaPorBeneficiario
                ? ('$ ' + formatCurrency(row.cuotaInscripcionValor || 0))
                : '-' }}
            </td>
            <td mat-footer-cell *matFooterCellDef>
              <strong>$ {{ formatCurrency(totalCuotaInscripcionTabla || 0) }}</strong>
            </td>
          </ng-container>

          <ng-container matColumnDef="descuentoProntoPago">
            <th mat-header-cell *matHeaderCellDef>% DESCUENTO PRONTO PAGO</th>
            <td mat-cell *matCellDef="let row">{{ row.descuentoProntoPago || 0 }}%</td>
            <td mat-footer-cell *matFooterCellDef><strong>{{ (totalDescuentoProntoPago || 0) | number:'1.1-1' }}%</strong></td>
          </ng-container>

          <ng-container matColumnDef="valorTotalPeriodoProntoPago">
            <th mat-header-cell *matHeaderCellDef>{{ etiquetaColumnaValorTotal }}</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.valorTotalPeriodoProntoPago || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalValorTotalPeriodoProntoPago || 0)
                }}</strong></td>
          </ng-container>

          <ng-container matColumnDef="precioBaseTarifaAsociado">
            <th mat-header-cell *matHeaderCellDef>PRECIO BASE TARIFA COMO ASOCIADO</th>
            <td mat-cell *matCellDef="let row">$ {{ formatCurrency(row.precioBaseTarifaAsociado || 0) }}</td>
            <td mat-footer-cell *matFooterCellDef><strong>$ {{ formatCurrency(totalPrecioBaseTarifaAsociado || 0) }}</strong>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button type="button" class="lock-allowed-eye" aria-label="Ver" (click)="abrirDetalleCotizacion(row)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">No hay datos para mostrar.</td>
          </tr>
        </table>
      </div>

      <div class="paginator-row">
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
        <!-- <span>{{ currentPage }} de {{ totalPages }} páginas</span> -->
      </div>
    </section>
  </mat-card-content>
</mat-card>